import styled from 'styled-components';

export const FooterSection = styled.div `
    text-align: center;
    padding: 10px 0;
    border-top: 1px solid #ccc;
`
export const Text = styled.p `
    color: #888;

`